import { Paper, Text } from '@mantine/core'
import dayjs from 'dayjs'
import 'dayjs/locale/fi'

dayjs.locale('fi')

interface BookingSummaryProps {
  selectedTime: Date
  selectedEndTime: Date
  cityLabel: string
}

export function BookingSummary({
  selectedTime,
  selectedEndTime,
  cityLabel,
}: BookingSummaryProps) {
  const formattedDateTime = dayjs(selectedTime).format('dddd, D.MM [klo] HH:mm')
  const estimatedEndTime = dayjs(selectedEndTime).format('HH:mm')

  return (
    <Paper withBorder p="md" bg="gray.0">
      <Text size="sm" fw={500} mb="xs">
        Valitsemasi aika
      </Text>
      <Text size="sm">
        {formattedDateTime} ({cityLabel})
      </Text>
      <Text size="sm" c="dimmed" mt={4}>
        Arvioitu päättymisaika klo {estimatedEndTime}
      </Text>
    </Paper>
  )
}
